module.exports = __webpack_public_path__ + "img/Underlay-2.1a9be878.png";